import { lazy } from 'react';

const FlashCards = lazy(() => import('../../components/Review/FlashCards'));
const AddFlashCard = lazy(() => import('../../components/Review/AddFlashCards'));
const HardFlashcards = lazy(() => import('../../components/Review/HardFlashcards'));
const TopicFlashCards = lazy(() => import('../../components/today/TopicFlashCards'));
const Subject = lazy(() => import('../../components/home/Subjects'));
const Topic = lazy(() => import('../../components/home/Topic'));
const Section = lazy(() => import('../aiChat/components/Section'));
const Dashboard = lazy(() => import('../../components/Review/dashboard/Dashboard'));
const Cost = lazy(() => import('../../components/Review/dashboard/cost/Cost'));
const Today = lazy(() => import('../../components/today/Today'));
const SharedFlashcardsPage = lazy(() => import('../../pages/Flashcards/SharedFlashcardsPage'));
const SharedStudyBundlePage = lazy(() => import('../../pages/Shared/SharedStudyBundlePage'));

export const flashcardPublicRoutes = [
  { path: '/flashcards/shared', element: <SharedFlashcardsPage /> },
  { path: '/share/study-bundle', element: <SharedStudyBundlePage /> },
];

export const flashcardProtectedRoutes = [
  { path: '/flashcards', element: <FlashCards /> },
  { path: '/subject', element: <Subject /> },
  { path: '/subject/:subjectId/topics', element: <Topic /> },
  { path: '/subject/:subjectId/topics/:topicId/sections', element: <Section /> },
  { path: '/subject/:subjectId/topics/:topicId/flashcard_add', element: <AddFlashCard /> },
  { path: '/subject/:subjectId/topics/:topicId/section/:sectionId/flashcards_review', element: <FlashCards /> },
  { path: '/subject/:subjectId/topics/:topicId/flashcards_review', element: <FlashCards /> },
  { path: '/subject/:subjectId/topics/:topicId/section/:sectionId/hard-flashcards_review', element: <HardFlashcards /> },
  { path: '/home/dashboard', element: <Dashboard /> },
  { path: '/usage', element: <Cost /> },
  { path: '/due-today', element: <Today /> },
  { path: '/due-today/subject/:subjectId/topic/:topicId', element: <TopicFlashCards /> },
];
